import { Distrolist } from './distrolist.types';
import { GuestStatus, GuestType } from './guest.enums';
import { MultiSessionPlusOneGuest, PlusOneGuest } from './plus-one.types';

// Re-export enums for backwards compatibility
export { GuestStatus, GuestType } from './guest.enums';

export interface SurveyResponseQuestion {
  type: string;
  label: string;
  options: string[] | null;
  sortOrder: number;
}

export interface SurveyResponses {
  [key: string]: {
    question: SurveyResponseQuestion;
    response: string[] | string;
    submittedAt: string;
  };
}

export interface Guest {
  gid: string;
  email: string;
  department: string;
  firstName: string;
  lastName: string;
  status: GuestStatus;
  zoomStatus: string;
  meetStatus: string;
  surveyResponses?: SurveyResponses | null;
  lastUpdatedAt: string;
  picture?: string;
  userId?: string;
  isCheckedIn?: boolean;
  isAttended?: boolean;
  isZoomAttended?: boolean;
  isMeetAttended?: boolean;
  isSelfCheckin?: boolean;
  associatedDistrolists?: Distrolist[];
  profilePictureUrl?: string | null;
  guestType?: GuestType;
  plusOnes?: PlusOneGuest[] | MultiSessionPlusOneGuest[];
}

export interface CheckinGuest {
  userId: string;
  firstName?: string;
  lastName?: string;
  profilePictureUrl?: string | null;
  status?: GuestStatus;
  isCheckedIn?: boolean;
  isZoomAttended?: boolean;
  isMeetAttended?: boolean;
  isSelfCheckin?: boolean;
  email?: string;
}

export interface GuestStats {
  attended: number;
  attendedInternal: number;
  attendedDropin?: number;
  cancelled: number;
  confirmed: number;
  incomplete: number;
  interested: number;
  invited: number;
  waitlisted: number;
  actionRequired: number;
  feedbackSentCount: number;
}

export interface GuestsPlatformConfirmationsStats {
  calendar?: number;
  slack?: number;
  eventPage?: number;
}

export interface CheckinPlusOneGuest {
  __typename: 'PlusOneGuest';
  plusOneId: number;
  firstName: string;
  lastName: string;
  status: GuestStatus;
  isCheckedIn?: boolean;
  isSelfCheckin?: boolean;
  owner: {
    gid: string;
    firstName: string;
    lastName: string;
  };
}

export type CheckinGuestListItem = (CheckinGuest & { __typename?: 'Guest' }) | CheckinPlusOneGuest;

export const isCheckinPlusOneGuestItem = (
  item: CheckinGuestListItem
): item is CheckinPlusOneGuest =>
  // eslint-disable-next-line no-underscore-dangle
  item.__typename === 'PlusOneGuest';

export interface GuestListPlusOneGuest extends PlusOneGuest {
  __typename: 'PlusOneGuest';
  owner: {
    gid: string;
    firstName: string;
    lastName: string;
  };
  lastUpdatedAt: string;
}

export type GuestListItem = (Guest & { __typename?: 'Guest' }) | GuestListPlusOneGuest;

export const isPlusOneGuestItem = (item: GuestListItem): item is GuestListPlusOneGuest =>
  // eslint-disable-next-line no-underscore-dangle
  item.__typename === 'PlusOneGuest';
